import { gql } from 'graphql-request';

export default gql`query($filter: FormInput) {
    luminaireConfigAvailability(filter: $filter) {
        items {
            id
            diode_current
            max_power
            total_diodes
            surge_protection_ln
            surge_protection_ln_pe
            surge_protection_mn_label
            surge_protection_name
            surge_protection_id
            surge_voltage
            power
            flux
            power_factor
            led_module_ids
            diode_id
            luminous_efficacy
            manufacturer_id
            driver_power_utilization
            driver_feature_ids
            driver_rank_id
        }
		min_luminous_efficacy
        max_luminous_efficacy
        count
        bin_id
        driver_features {
            id
            value
        }
    }
}`;